import { EventData } from "@/contexts/event/EventContext";

/**
 * Exports event participants to CSV format
 * @param event The event with participant details
 * @param filename Optional custom filename
 */
export function exportParticipantsToCsv(event: EventData, filename?: string) {
  const participants = event.participantDetails || [];
  const waitlist = event.waitingListDetails || [];
  
  // CSV header
  const headers = ['#', 'Name', 'Phone', 'Email', 'Groups', 'Status', 'Signup Time'];
  
  // Build CSV rows
  const rows: string[][] = [];
  
  // Add participants
  participants.forEach((p, idx) => {
    const signupTime = p.joinedAt 
      ? `="${p.joinedAt.toISOString().replace('T', ' ').replace('Z', '')}"`
      : '';
    rows.push([
      String(idx + 1),
      p.name || 'Unknown',
      p.phone || '',
      p.email || '',
      p.groups?.join(', ') || '',
      'Confirmed',
      signupTime
    ]);
  });
  
  // Add waitlist
  waitlist.forEach((p, idx) => {
    const signupTime = p.joinedAt 
      ? `="${p.joinedAt.toISOString().replace('T', ' ').replace('Z', '')}"`
      : '';
    rows.push([
      String(participants.length + idx + 1),
      p.name || 'Unknown',
      p.phone || '',
      p.email || '',
      p.groups?.join(', ') || '',
      'Waitlist',
      signupTime
    ]);
  });
  
  // Convert to CSV string
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell.replace(/"/g, '""')}"`).join(','))
  ].join('\n');
  
  // Add BOM for Excel UTF-8 compatibility
  const bom = '\uFEFF';
  const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Generate filename
  const dateStr = event.date.toISOString().split('T')[0];
  const slug = event.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const finalFilename = filename || `${slug}-${dateStr}.csv`;
  
  // Trigger download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = finalFilename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
